(function() {
  define('tlhFiltersPhone',['angular'], function() {
    'use strict';
    return angular.module('tlhFiltersPhone', []).filter('tlhPhone', function() {
      return function(phoneNumber) {
        if (phoneNumber && phoneNumber.length === 10) {
          return phoneNumber.replace(/(\d{2})(\d{2})(\d{2})(\d{2})(\d{2})/, '$1 $2 $3 $4 $5');
        } else {
          return phoneNumber;
        }
      };
    });
  });

}).call(this);

//# sourceMappingURL=phone.js.map
;
